import { omitBy, isNil } from 'lodash';
import { useContext } from 'react';
import { ToolbarContext, EditorContext } from 'ricos-context';
import { DEFAULT_LINE_SPACING } from '../defaults.js';
import '../types.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const useCurrentSpacing = () => {
  const { defaultLineSpacing: defaultSpacing } = useContext(ToolbarContext);
  const { getEditorCommands } = useContext(EditorContext);
  const editorCommands = getEditorCommands();
  const currentSpacing = editorCommands.getBlockSpacing();
  return __spreadValues(__spreadValues(__spreadValues({}, DEFAULT_LINE_SPACING), omitBy(defaultSpacing, isNil)), omitBy(currentSpacing, isNil));
};

export { useCurrentSpacing };
//# sourceMappingURL=get-current-selection.js.map
